import { DispositionWeekPeriodResponse } from '@/types/service-response'

export class WorkRhythm {
  public constructor (
    readonly id: number,
    readonly name: string
  ) {}

  static createFromResponse (responseData: DispositionWeekPeriodResponse[]): Array<WorkRhythm> {
    let result: Array<WorkRhythm> = []
    if (responseData) {
      result = responseData.map((item: DispositionWeekPeriodResponse ) => {
        return new WorkRhythm(
          item.ID,
          item.Bezeichnung
        )
      })
    }
    return result
  }
}
